import { graphql } from '~/types/gql/generated'

export const LoginMutation = graphql(`
  mutation Login($loginInfo: LoginInput!) {
    login(loginInfo: $loginInfo) {
      accessToken
    }
  }
`)
